import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

export type GuestOfficePersistenceInput = {
	officeUid: string;
	options?: { currentOfficeUidBeforeGuest?: string };
	contextActiveOfficeUid: string | null;
	getActiveOfficeUid: () => string | null;
	setLastRealOfficeUidBeforeGuest: (uid: string) => void;
};

export function persistRealOfficeBeforeGuestSwitch(input: GuestOfficePersistenceInput): void {
	const { officeUid, options, contextActiveOfficeUid, getActiveOfficeUid, setLastRealOfficeUidBeforeGuest } = input;
	if (officeUid !== "GUEST_FOLDERS") {
		return;
	}

	const fromUi = options?.currentOfficeUidBeforeGuest;
	const fromContext =
		contextActiveOfficeUid && contextActiveOfficeUid !== "GUEST_FOLDERS" ? contextActiveOfficeUid : null;
	const current = fromUi ?? fromContext ?? getActiveOfficeUid();
	LoggerService.info("🔍 [setActiveOffice] Persisting last real office before GUEST_FOLDERS", {
		fromUi,
		fromContext,
		getActiveOfficeUid: getActiveOfficeUid(),
		current,
	});
	if (current && current !== "GUEST_FOLDERS") {
		setLastRealOfficeUidBeforeGuest(current);
	}
}
